import React, { Component } from 'react'
import { connect } from 'react-redux'
import toast from 'react-hot-toast';
import DropdownFlat from '../Components/DropdownFlat'
import env from '../ENV';
import { GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchForDCListing, gettemplatemasterData, postDispatchClearenceDetails } from '../store/actions/dispatchOrderDetailsActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class DispatchIssueDC extends Component {
    constructor(props) {
        super(props);
        this.state = {
            issueDC: [],
            tabledata: [],
            dropdownArray: [],
            checkedArray: [],
            select: false,
            tabledataOfIssuedDC:[]
        }
    }

    //------------API CALL----------------------
    componentDidMount() {
        this.dataSync()
    }
    dataSync = async () => {
        await this.props.gettemplatemasterData()
        await this.props.GetPOAndLineItemListForDispatch()
        await this.props.GetPOAndLineItemListForDispatchForDCListing()
        let tabledata = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemDetails.recordset.filter((data) => data.DispatchClearenceId != null)
        let tabledataOfIssuedDC = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchForDCListing.recordset.filter((data) => data.DispatchClearenceId != null)
        let dropdownArray = await this.props.dispatchOrderDetailsReducer.getdispatchtemplatemasterdata.recordset
        await this.setState({ tabledata, dropdownArray,tabledataOfIssuedDC })
    }
    //Check Checkbox Function
    onChange(id) {
        let selected = this.state.selected
        // instead of using indexOf, we can use findIndex to look through array of objects
        let find = selected.findIndex(item => item.id === id)

        if (find > -1) {
            selected.splice(find, 1)
        } else {
            // We can use find to get the item based on its id
            selected.push(this.state.issueDC.find(item => item.id === id))
        }
        this.setState({ selected })
        console.log(selected)
    }

    getInitialState() {
        return { Select_template: 'Select' };
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
        console.log(e.target.value)
    }

    HandleissueDCButton = async() => {
        let templatedata = []
        this.state.checkedArray.map(async(data)=>{
            templatedata = {
                documentId: data,
                indicator: 5,
            }
            await this.props.postDispatchClearenceDetails(templatedata)
            await toast.success(`Data has been added`, {
                duration: 4000
            });
        })
        let checkedArray =[]
        await this.setState({checkedArray})
        await this.dataSync()

    }
    handleTemplateChange = async (e, index) => {
        let tabledataOfIssuedDC = [...this.state.tabledataOfIssuedDC]
        tabledataOfIssuedDC[index].TemplateId = e.target.value
        await this.setState({ tabledataOfIssuedDC })
    }
    handleSaveTemplateID = async (DispatchClearenceId, TemplateId) => {
        console.log(DispatchClearenceId, TemplateId, "KLKLKLKLKL")

        let templatedata = {
            RequestedQuantity: 0,
            documentId: DispatchClearenceId,
            indicator: 4,
            issuedQuantity: 0,
            BillingSchNo: 0,
            TemplateId: TemplateId,
        }
        await this.props.postDispatchClearenceDetails(templatedata)
        await toast.success(`Data has been added`, {
            duration: 4000
        });
    }
    handleSingleCheckBoxChange = (index) => {
        var checkedArray = [...this.state.checkedArray]
        if (!checkedArray.includes(index)) {
            checkedArray.push(index)
        } else {
            checkedArray = checkedArray.filter(item => item !== index)
        }
        this.setState({ checkedArray });
    };
    handleChangeChkBoxAll = async () => {
        let select = !this.state.select;
        var checkedArray = []
        await this.state.tabledata.map((item) => {
            if (select == true) {
                checkedArray.push(item.PurchaseOrderLineId)
            }
        })
        await this.setState({ select: select, checkedArray });
    };

    render() {
        console.log(this.state.tabledata,"HGHGHGHGHGHG")
        return (
            <div className="w-60 mx-auto shadow" style={{ marginTop: "5%" }}>
                <table className="table table-bordered mt-4">
                    <thead className="table-primary" style={{ backgroundColor: "#0989CB", color: "white" }}>
                        <tr>
                            <th scope="col"><input type="checkbox" onClick={this.handleChangeChkBoxAll} checked={this.state.select} /></th>
                            <th scope="col">Project No</th>
                            <th scope="col">DC No</th>
                            <th scope="col">PO No</th>
                            <th scope="col">Line Item No</th>
                            <th scope="col">Select Template</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.tabledataOfIssuedDC.map((item, index) => {
                            return (
                                <tr key={item.PurchaseOrderLineId}>
                                    <td scope="row">
                                        <input type="checkbox"
                                            checked={this.state.checkedArray.includes(item.DispatchClearenceId) ? true : false}
                                            disabled={item.Issued == 2 ? true : false}
                                            //disabled={item.IssuedQuantity == item.POLineItemQuantity ? true : false}
                                            onChange={() => this.handleSingleCheckBoxChange(item.DispatchClearenceId)} />
                                    </td>
                                    <td>
                                    {item.PlantCode == "8501" || item.PlantCode == "8502" ? item.WBSCode.slice(0,11) : item.WBSCode.slice(0,6)}
                                    </td>
                                    <td>{"DC-" + item.DispatchClearenceId}</td>
                                    <td>{item.POSAPId}</td>
                                    <td>{item.POLineItemSAPCode}</td>
                                    <td>
                                        <select className="form-select p-2" 
                                        disabled={item.Issued == 2 ? true : false}
                                        //disabled={item.IssuedQuantity == item.POLineItemQuantity ? true : false}
                                        aria-label="Default select example" onChange={(e) => this.handleTemplateChange(e, index)} value={item.TemplateId} onBlur={() => this.handleSaveTemplateID(item.DispatchClearenceId, item.TemplateId)}>
                                            <option selected disabled="true">Open this select menu</option>
                                            {this.state.dropdownArray.map((droplist, index) => (<option value={droplist.dispatchTemplateId}>{droplist.TemplateName}</option>))}
                                        </select>
                                    </td>
                                    <td>
                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DispatchClearenceId + "/download"} target="_blank" download>
                                        <FontAwesomeIcon className="" icon="file-download" size="lg" cursor="pointer" color="black"/>
                                    </a>
                                    {item.Issued != 2 ? 
                                        <FontAwesomeIcon className="ml-2" icon="history" size="lg" color="blue"/> 
                                    : null}
                                    </td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </table><br />
                <div className="float-right"><button type="submit" className="btn btn-danger btn-lg mr-4" onClick={() => this.HandleissueDCButton()}>Issue DC</button></div><br /><br /><br />
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, { GetPOAndLineItemListForDispatch, GetPOAndLineItemListForDispatchForDCListing, gettemplatemasterData, postDispatchClearenceDetails })(DispatchIssueDC)
